import React from 'react';
import MaterialInput from 'components/Inputs/MaterialInput';

export default function TalentAddressUnitInput({ value, onChange, scope, disabled = false }: {
  value: string; onChange: (value: string) => void; scope: string; disabled?: boolean;
}) {
  return <MaterialInput id={`${scope}-address-unit`} name="addressUnit" label="Unit / Suite / Apt (optional)"
    value={value} disabled={disabled} type="text" onChange={event => onChange(event.target.value)}
    inputProps={{ inputProps: { 'data-testid': `${scope}-address-unit`, maxLength: 100, autoComplete: 'address-line2' } }} />;
}
